import { useMemo } from 'react';

import type { FilterConfig } from '@/productDiscovery/Listings/interfaces/filterConfig';

export const useCertificationsFiltersConfigs = (
  filtersConfig: FilterConfig[],
): FilterConfig[] =>
  useMemo(
    () =>
      filtersConfig?.filter(({ attributeName }) =>
        ['is_local', 'is_eco_responsible'].includes(attributeName),
      ) || [],
    [filtersConfig],
  );
